// extracted by mini-css-extract-plugin
module.exports = {"strip":"Footer_strip__2O_VV","center":"Footer_center__2tCHx"};